// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","item":"PostMainImageDocument_item__3LMuN","link":"PostMainImageDocument_link__NeD6i"};